import { render, staticRenderFns } from "./reviewTeacher.vue?vue&type=template&id=15da1230&scoped=true&"
import script from "./reviewTeacher.vue?vue&type=script&lang=js&"
export * from "./reviewTeacher.vue?vue&type=script&lang=js&"
import style0 from "./reviewTeacher.vue?vue&type=style&index=0&id=15da1230&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da1230",
  null
  
)

export default component.exports